import { Box, Card, Divider, Grid, Stack, Typography } from '@mui/material';
import React from 'react'
import OrderFile from './OrderFile';

const OrderDocumentContainer = ({
    order
}) => {
    console.log(order)
    return ( 
        <>
        <Card sx={{px:2, py:2}}>
            <Typography variant='subtitle1'>Receta</Typography>
            <Divider sx={{my:1}} />
            <Grid container spacing={3} justifyContent='center'>
                    <Grid item xs={12} >
                        <Stack spacing={0}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <OrderFile 
                                        id="recipe_front"
                                        title="Frente"
                                        src={order?.recipe_front}
                                        order_id={order?.id_order}
                                        user_id={order?.user_id}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <OrderFile 
                                        id="recipe_back"
                                        title="Reverso"
                                        src={order?.recipe_back}
                                        order_id={order?.id_order}
                                        user_id={order?.user_id}
                                    />
                                </Grid>
                            </Grid>
                        </Stack>
                    </Grid>
                
                </Grid> 
            </Card>
        </>
     );
}
 
export default OrderDocumentContainer;

